import { useContext } from "react";

import { Link, NavLink } from "react-router-dom";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { DEFAULT_LOGO_URL } from "../constants";
import { UserProgramContext } from "../../context/user-program/user-program";
import { OutlinedButton } from "./outlined-button";
import ShopIcon from "@mui/icons-material/Shop";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSignOut } from "../../hooks/useSignOut";

export const Navbar = () => {
  const { role } = useContext(UserProgramContext);

  const { signOut } = useSignOut();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <Grid container xs={12} justifyContent="space-between" item>
      <Grid container display="flex" justifyContent="space-between">
        <Box>
          <Link to="/">
            <img
              src={DEFAULT_LOGO_URL}
              alt="Clinic Logo"
              style={{ height: "3em" }}
            />
          </Link>
        </Box>

        {role === "admin" && (
          <Box display="flex" flexDirection="row" alignItems="center">
            <NavLink
              to="/"
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Home
            </NavLink>
            {"|"}
            <NavLink
              to="/patients"
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Patientenliste
            </NavLink>

            {"|"}
            <NavLink
              to="/clinic-dashboard"
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Klinik-Dashboard
            </NavLink>
            <NavLink
              to={"/clinic-dashboard"}
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Klinik-Gewicht-Dashboard
            </NavLink>
            <NavLink
              to="/admin"
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Admin-Panel
            </NavLink>
          </Box>
        )}

        {["clinic-weight"].includes(role) && (
          <Box display="flex" flexDirection="row" alignItems="center">
            <NavLink
              to={"/patients-clinic-weight"}
              style={({ isActive }) => ({
                color: "black",
                fontWeight: isActive ? "700" : "normal",
                textDecoration: isActive ? "underline" : "none",
                marginInline: 10,
              })}
            >
              Weight Doctors
            </NavLink>
          </Box>
        )}

        <div>
          {role === "patient" && (
            <Link to="/shop" style={{ textDecoration: "none" }}>
              <OutlinedButton
                color="inherit"
                size={isMobile ? "small" : "medium"}
                startIcon={<ShopIcon />}
              >
                Shop
              </OutlinedButton>
            </Link>
          )}

          <Box component="span" sx={{ mx: 1 }} />

          <OutlinedButton
            color="inherit"
            size={isMobile ? "small" : "medium"}
            startIcon={<LogoutIcon />}
            onClick={signOut}
          >
            Abmelden
          </OutlinedButton>
        </div>
      </Grid>
    </Grid>
  );
};
